import UpdateArticlesInShopCategoryRequestModelBase from '../_generated/modelBases/update-articles-in-shop-category-request-model-base';

export default class UpdateArticlesInShopCategoryRequestModel extends UpdateArticlesInShopCategoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
